import { baseApi } from '../axios';

export const userActivity = async (data: any) => {
	const response = await baseApi.post('/user-progress', data);
	return response;
};

export const getAllActivity = async () => {
	const response = await baseApi.get('/user-progress/all');
	return response;
};
